// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1JnXB","content":"styles_content__3A1Ep","checkbox":"styles_checkbox__33mPB","checkboxLabel":"styles_checkboxLabel__3Ljvn"};